import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { ShareAltOutlined, MenuOutlined, DesktopOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

export default function PwaInstallHelpModal({ open, mode = 'desktop', onClose }) {
  const { t } = useTranslation();

  const title = t('common.installMobileApp');

  let intro;
  let steps;

  if (mode === 'ios') {
    intro = t('common.installIosIntro');
    steps = [
      <ShareAltOutlined key="i1" />,
      t('common.installIosStep1'),
      t('common.installIosStep2'),
      t('common.installIosStep3'),
    ];
  } else if (mode === 'android') {
    intro = t('common.installAndroidIntro');
    steps = [
      <MenuOutlined key="a1" />,
      t('common.installAndroidStep1'),
      t('common.installAndroidStep2'),
      t('common.installAndroidStep3'),
    ];
  } else {
    intro = t('common.installDesktopIntro');
    steps = [
      <DesktopOutlined key="d1" />,
      t('common.installDesktopStep1'),
      t('common.installDesktopStep2'),
      t('common.installDesktopStep3'),
    ];
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          {t('common.close')}
        </Button>,
      ]}
      title={title}
      className="pwa-install-ios-modal"
      width={400}
      centered
    >
      <Paragraph>{intro}</Paragraph>
      <ol className="pwa-install-ios-steps">
        <li>{steps[0]} {steps[1]}</li>
        <li>{steps[2]}</li>
        <li>{steps[3]}</li>
      </ol>
    </Modal>
  );
}
